import { NotificationService } from 'src/app/shared/services/notification.service';

import { ConfirmationService, SelectItem } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { ManualControlServices } from './../services/manual-control-services';
import { FoodControlList } from './../models/food-control-list';
import { inject, Component, OnInit } from '@angular/core';
import { FoodSafetyManualCompleteChecklist } from '../../shared/models/complete-checklist';
import { BaseServices } from '../../kuba.services';
import { TranslateService } from '@ngx-translate/core';
import { FeatureKey, Rights } from '../../../_models';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TaskService } from 'src/app/kuba/task-manager/services/task.services';
import { managetemperaturecontrol } from 'src/app/kuba/foodsafety/models/managetemperaturecontrol';
import { Repetition } from '../models/food-control';
import { Subscription } from 'rxjs';
@Component({
  selector: 'manual-control-list',
  templateUrl: 'manual-control-list.component.html',
  standalone: false
})
export class ManualControlListComponent implements OnInit {
  private readonly notifications = inject(NotificationService);
  manualobjects: FoodControlList[];
  parentId: number;
  featureId: any;
  parentKey: number;
  FoodSafetyManualCompleteChecklist: FoodSafetyManualCompleteChecklist;
  additionalData: any;
  routeSub: any;
  displayDialog: boolean;
  manageTempControlForm: FormGroup;
  weekDays: SelectItem[];
  executionAndFollowupusers: SelectItem[];
  tempControl = new managetemperaturecontrol();
  manageTempControl: any;
  editManageTempControl = false;
  Id: number;
  isChanged = false;
  private subscriptions: Subscription[] = [];
  canAdministrate = true;
  originalObjects: FoodControlList[] = [];

  constructor(
    private manualControlService: ManualControlServices,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private router: Router,
    private translate: TranslateService,
    private fb: FormBuilder,
    private taskService: TaskService
  ) {
    let list = <FoodControlList[]>this.route.snapshot.data['list'];
    this.originalObjects = this.manualobjects = list;
  }

  ngOnInit() {
    let workingModule = JSON.parse(sessionStorage.getItem('workingModule')).id;
    if (workingModule != null) {
      this.featureId = workingModule;
    }
    // To hide side menu bar
    document.querySelector('body').classList.remove('opened');
    this.parentId = this.route.snapshot.parent.parent.params['id'];
    this.parentKey = this.route.snapshot.parent.parent.data['parent'];
    this.subscriptions.push(
      this.manualControlService
        .getManualControlByParent(this.parentId)
        .subscribe(res => {
          this.manualobjects = this.normalizeOrderNumbers(res);
        })
    );

    this.additionalData = {
      fileName: 'List of Objects',
      header: 'List of Objects',
      businessId: BaseServices.BusinessId,
      cultureInfo: BaseServices.userCultureInfo(),
      columnNames: [
        { title: 'Object Name', dataKey: 'ObjectName' },
        { title: 'Temp_min', dataKey: 'MinTemp' },
        { title: 'Temp_max', dataKey: 'MaxTemp' },
        { title: 'Description', dataKey: 'Description' }
      ]
    };

    this.manageTempControlForm = this.fb.group({
      Repetition: [''],
      EmailNotificationpastDeadline: ['']
    });

    this.bindDropdown();
    let manageTemp = this.route.snapshot.data['manageTemp'];
    if (manageTemp != null) {
      let repDays = [];
      if (manageTemp.Repetition) {
        manageTemp.Repetition.forEach((element: any) => {
          repDays.push(element.RepetitionId);
        });
      }
      let manageTempControlForm = {
        Repetition: repDays,
        EmailNotificationpastDeadline: manageTemp
          ? manageTemp.EmailNotificationPastDeadline
          : 0
      };
      (<FormGroup>this.manageTempControlForm).setValue(manageTempControlForm, {
        onlySelf: true
      });
    }

    // Only administrators of the module may add, edit, delete or reorder objects.
    // Mirrors feature-document.component.ts, which gates the same way per feature.
    if (+BaseServices.roleId === 4) {
      this.canAdministrate = false;
    } else if (+BaseServices.roleId === 5) {
      if (this.featureId == FeatureKey.FOOD_SAFETY) {
        this.canAdministrate = this.isUserRights(
          Rights.ADMINISTRATE_FOOD_SAFETY
        );
      } else if (this.featureId == FeatureKey.KUBA_CONTROL) {
        this.canAdministrate = this.isUserRights(
          Rights.ADMINISTRATE_KUBA_CONTROL
        );
      } else {
        this.canAdministrate = false;
      }
    } else {
      this.canAdministrate = true;
    }
  }

  isUserRights(rightsId: number): boolean {
    return BaseServices.checkUserRights(+rightsId, BaseServices.UserRole);
  }

  getTempControl() {
    this.subscriptions.push(
      this.manualControlService
        .getManualControlByParent(this.parentId)
        .subscribe(res => {
          this.originalObjects = res;
        })
    );
  }
  editFoodControl(id) {
    this.router.navigate(['./../edit', id], { relativeTo: this.route });
  }

  deleteFoodControl(manualobjects) {
    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.subscriptions.push(
          this.manualControlService
            .deleteFoodControl(manualobjects)
            .subscribe(result => {
              this.subscriptions.push(
                this.manualControlService
                  .getManualControlByParent(this.parentId)
                  .subscribe(res => {
                    this.manualobjects = res;
                    this.notifications.success('UI_NOTIFICATIONS.DELETED');
                  })
              );
            })
        );
      }
    });
  }

  completeChecklist() {
    this.router.navigate(
      ['../../../../../fs-complete-checklist/new/' + this.parentId],
      { relativeTo: this.route }
    );
    this.FoodSafetyManualCompleteChecklist =
      new FoodSafetyManualCompleteChecklist();
    this.FoodSafetyManualCompleteChecklist.FeatureId = this.featureId;
    this.FoodSafetyManualCompleteChecklist.FeatureKey = this.parentId;
    this.FoodSafetyManualCompleteChecklist.BusinessId = BaseServices.BusinessId;
    this.FoodSafetyManualCompleteChecklist.Id =
      this.route.snapshot.params['Id'];
  }

  showDialogToAdd() {
    this.displayDialog = true;
  }

  cancel() {
    this.displayDialog = false;
  }

  bindDropdown() {
    this.weekDays = [];
    this.executionAndFollowupusers = [];

    this.subscriptions.push(
      this.translate.stream('WEEKDAYS_LIST').subscribe(val => {
        this.weekDays = [];
        this.weekDays.push(
          { label: val.MONDAY, value: 1 },
          { label: val.TUESDAY, value: 2 },
          { label: val.WEDNESDAY, value: 3 },
          { label: val.THURSDAY, value: 4 },
          { label: val.FRIDAY, value: 5 },
          { label: val.SATURDAY, value: 6 },
          { label: val.SUNDAY, value: 7 }
        );
      })
    );

    this.executionAndFollowupusers = [];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.executionAndFollowupusers = [];
        this.executionAndFollowupusers.push({ label: val.SELECT, value: null });
        this.subscriptions.push(
          this.taskService
            .getAssignedUsers(
              BaseServices.BusinessId,
              this.featureId,
              this.parentId,
              BaseServices.ApplicationId
            )
            .subscribe((users: any) => {
              // New array reference so PrimeNG 21's p-select re-renders its options.
              this.executionAndFollowupusers = [
                ...this.executionAndFollowupusers,
                ...(Array.isArray(users) ? users : []).map((element: any) => ({
                  label: element.Name,
                  value: element.Id
                }))
              ];
              this.manageTempControlForm.patchValue({
                EmailNotificationpastDeadline:
                  this.manageTempControlForm.value.EmailNotificationpastDeadline
              });
            })
        );
      })
    );
  }

  onSubmitForm() {
    if (this.manageTempControlForm.valid) {
      this.displayDialog = false;
      let manageTemp = this.route.snapshot.data['manageTemp'];
      this.tempControl.Id = manageTemp != null ? manageTemp.Id : 0;
      this.tempControl.FoodSafetyId = +this.parentId;
      this.tempControl.ControlId = +this.parentId;
      this.tempControl.Repetition = this.manageTempControlForm.value.Repetition;
      this.tempControl.CreatedBy = BaseServices.UserId;

      let weekdays = [];
      if (this.manageTempControlForm.value.Repetition) {
        this.manageTempControlForm.value.Repetition.forEach(result => {
          let rep = new Repetition();
          rep.RepetitionId = result;
          weekdays.push(rep);
        });
      }
      this.tempControl.Repetition = weekdays;
      this.tempControl.EmailNotificationPastDeadline =
        this.manageTempControlForm.value.EmailNotificationpastDeadline == '' ||
        this.manageTempControlForm.value.EmailNotificationpastDeadline == null
          ? 0
          : this.manageTempControlForm.value.EmailNotificationpastDeadline;
      this.subscriptions.push(
        this.manualControlService
          .saveManageTempControl(this.tempControl)
          .subscribe(result => {
            this.displayDialog = false;
            this.notifications.success('UI_NOTIFICATIONS.SAVED');
          })
      );
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }

  setOrderNumber(
    orderNumber: number,
    checklistData: FoodControlList[],
    index: number
  ) {
    checklistData[index].OrderNumber = orderNumber;
    const name = checklistData[index].ObjectName;
    const isIncrease = orderNumber > index;

    checklistData.sort((a, b) => {
      if (a.OrderNumber !== b.OrderNumber) {
        return a.OrderNumber - b.OrderNumber;
      }
      if (a.ObjectName === name && b.ObjectName !== name) {
        return isIncrease ? 1 : -1;
      }
      if (b.ObjectName === name && a.ObjectName !== name) {
        return isIncrease ? -1 : 1;
      }
      return 0;
    });

    this.normalizeOrderNumbers(checklistData);

    this.isChanged = !this.arraysEqual(this.originalObjects, checklistData);
  }

  normalizeOrderNumbers(checklistData: FoodControlList[]): FoodControlList[] {
    checklistData.forEach((element, index) => {
      element.OrderNumber = index + 1;
    });
    return checklistData;
  }
  arraysEqual(arr1: FoodControlList[], arr2: FoodControlList[]): boolean {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (
        arr1[i].OrderNumber !== arr2[i].OrderNumber ||
        arr1[i].ObjectName !== arr2[i].ObjectName
      ) {
        return false;
      }
    }
    return true;
  }

  saveOrderNumber(list: FoodControlList[]) {
    const foodControlOrderNumber = list.map(item => {
      return {
        Id: item.Id,
        OrderNumber: item.OrderNumber
      };
    });
    if (this.featureId == FeatureKey.FOOD_SAFETY) {
      this.manualControlService
        .updateManualControlOrderNumber(foodControlOrderNumber)
        .subscribe(result => {
          this.getTempControl();
          this.isChanged = false;
        });
    } else {
      this.manualControlService
        .updateKubaControlOrderNumber(foodControlOrderNumber)
        .subscribe(result => {
          this.getTempControl();
          this.isChanged = false;
        });
    }
  }
}
